import Util from 'app/util'

import getters from './games/getters.js'
import mutations from './games/mutations.js'

export default {

    namespaced: true,

    state: {

        name: 'hindex',

        data: Util.filter.templates.hindex(),

        defaultValues: Util.filter.templates.hindex(),

        preset: 0,

        changed: false

    },
    
    getters: getters,
    mutations: mutations

}